import { Component, OnInit } from '@angular/core';
import { TipoEstupefacientes } from '../../../models/tipo-estupefacientes.model';
import { CatalogosService } from '../../../services/catalogos.service';

@Component({
  templateUrl: './lista-datos-estupefacientes.component.html',
  styleUrls: ['./lista-datos-estupefacientes.component.css'],
})

export class ListaRegistroEstupefacientesComponent implements OnInit {
  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio',
    },
    {
      label: 'Unidad de Estupefacientes',
      routerLink: '/estupefacientes',
    },
  ];

  tipos: TipoEstupefacientes[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {}

  ngOnInit():void {
    this.loading = true;
    this.catalogosService.getTiposProcesosEstupefacientes().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        const descripcion = p.descripcion.toString();
        array.push(p);
      });
      this.tipos = array;
    });
  }
}
